"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Variant = exports.Align = exports.Size = void 0;
var Size;

(function (Size) {
  Size["LARGE"] = "large";
  Size["NORMAL"] = "normal";
  Size["SMALL"] = "small";
})(Size = exports.Size || (exports.Size = {}));

var Align;

(function (Align) {
  Align["LEFT"] = "left";
  Align["CENTER"] = "center";
  Align["RIGHT"] = "right";
  Align["END"] = "end";
  Align["START"] = "start";
})(Align = exports.Align || (exports.Align = {}));

var Variant;

(function (Variant) {
  Variant["CALL_TO_ACTION"] = "callToAction";
  Variant["FILLED"] = "filled";
  Variant["OUTLINED"] = "outlined";
  Variant["OUTLINED_COLOR"] = "outlinedColor";
  Variant["OUTLINED_HOVER_COLOR"] = "outlinedHoverColor";
  Variant["OUTLINED_TEXT_COLOR"] = "outlinedTextColor";
  Variant["FLAT"] = "flat";
  Variant["FLAT_COLOR"] = "flatColor";
  Variant["DASH"] = "dash";
})(Variant = exports.Variant || (exports.Variant = {}));